export const useUserStore = defineStore('userData', () => {
  const isHidePriceCookie = useCookie('isHidePrice')

  const userData = ref({
    customerCode: '',
    email: '',
    email2: '',
    userGroup: '',
    companyName: '',
    //firstName: '',
    //lastName: '',
    isHidePrice: false
  })

  // const loggedIn = computed(() => {
  //   console.log(`loggedIn > userData.value: ${userData.value?.email}`)
  //   return !!userData.value && !!userData.value.email && existsCookie()
  // })

  // const existsUserData = computed(() => {email
  //   return !!userData.value && !!userData.value.email
  // })

  // computed
  const isAdmin = computed(() => {
    return ['N41', 'WEB_ADMIN'].includes(userData.value.userGroup)
  })

  const isSalesRep = computed(() => {
    return ['SALES_REP'].includes(userData.value.userGroup)
  })

  const setUserData = (_userData) => {
    //console.log(`setUserData() userData: ${_userData?.email}`, _userData)

    if (!_userData?.email) return

    userData.value.customerCode = _userData.customerCode
    userData.value.email = _userData.email
    userData.value.email2 = _userData.email2
    userData.value.userGroup = _userData.userGroup
    userData.value.companyName = _userData.companyName
    userData.value.isHidePrice = isHidePriceCookie.value ?? false
  }

  // const isLoggedIn = () => {
  //   return !!userData.value && !!userData.value.email && !!userCookie.value
  // }

  const isLoggedIn = () => {
    return !!userData.value && !!userData.value.email
  }

  const clearUserData = () => {
    //console.log('>> User Store > logout', isSalesRep.value)
    userData.value = {}
    navigateTo('/login')
    //companyCode.value = null
    //refreshCookie('pim_cAlias')
  }

  return { userData, isLoggedIn, isAdmin, isSalesRep, setUserData, clearUserData }
})
